import 'https://cdn.jsdelivr.net/gh/orestbida/cookieconsent@3.1.0/dist/cookieconsent.umd.js';

CookieConsent.run({
	disablePageInteraction: false,
	hideFromBots: true,
	mode: 'opt-out',
	cookie: {
		name: 'cookieConsent',
	},
	guiOptions: {
		consentModal: {
			layout: 'cloud',
			position: 'bottom center',
			equalWeightButtons: true,
			flipButtons: false,
		},
		preferencesModal: {
			layout: 'bar wide',
			position: 'right',
			equalWeightButtons: true,
			flipButtons: false,
		},
	},
	categories: {
		necessary: {
			enabled: true,
			readOnly: true
		},
		analytics: {
			enabled: true,
			autoClear: {
				cookies: [{
						name: /^(_ga)/,
					},
					{
						name: '_ga',
					}
				],
				reloadPage: false,
			},
			services: {
				ga: {
					label: 'Google Analytics',
					onAccept: function() {
						gtag('consent', 'update', {
							'analytics_storage': 'granted'
						});
					},
					onReject: function() {
						gtag('consent', 'update', {
							'analytics_storage': 'denied'
						});
					}
				},
			}
		},
		ads: {
			enabled: true,
			autoClear: {
				cookies: [{
						name: /^(_gcl)/,
					},
					{
						name: '_gcl',
					}
				],
				reloadPage: false,
			},
			services: {
				gads: {
					label: 'Google Ads',
					onAccept: function() {
						gtag('consent', 'update', {
							'ad_storage': 'granted',
							'ad_user_data': 'granted',
							'ad_personalization': 'granted'
						});
					},
					onReject: function() {
						gtag('consent', 'update', {
							'ad_storage': 'denied',
							'ad_user_data': 'denied',
							'ad_personalization': 'denied'
						});
					}
				},
			}
		}
	},
	language: {
		default: 'sr',
        autoDetect: 'document',
		translations: {
			'sr': {
				"consentModal": {
					"title": "Obaveštenje o kolačićima",
					"description": "Internet stranica koristi kolačiće (uključujući kolačiće trećih lica) koji su apsolutno neophodni za nesmetan rad web stranice. Već smo učitali ove kolačiće za vas, ali bismo takođe želeli da koristimo analitičke i reklamne kolačiće, za šta nam je potrebna vaša saglasnost. Možete da promenite svoju saglasnost za kolačiće u bilo kom trenutku na ovo dugme, gde možete pronaći dodatne informacije o kolačićima. Možete dati saglasnost zasebno za pojedinačne svrhe ili za sve odjednom.",
					"acceptAllBtn": "Prihvatam sve",

					"showPreferencesBtn": "Promeni podešavanje kolačića"
				},
				"preferencesModal": {
					"title": "Podešavanje upotrebe kolačića",
					"acceptAllBtn": "Prihvatam sve",

					"savePreferencesBtn": "Sačuvaj postavke",
					"closeIconLabel": "Zatvori",
					"sections": [{
							"title": "Upotreba kolačića",
							"description": "Internet stranica koristi kolačiće (uključujući kolačiće trećih lica) koji su apsolutno neophodni za nesmetan rad web stranice. Već smo učitali ove kolačiće za vas, ali bismo takođe želeli da koristimo analitičke i reklamne kolačiće, za šta nam je potrebna vaša saglasnost. Možete da promenite svoju saglasnost za kolačiće u bilo kom trenutku na ovo dugme, gde možete pronaći dodatne informacije o kolačićima. Možete dati saglasnost zasebno za pojedinačne svrhe ili za sve odjednom."
						},
						{
							"title": "Analitika",
							"description": "Omogućavaju nam da pratimo i analiziramo aktivnosti korisnika web stranica u cilju poboljšanja funkcionalnosti web stranica ili naše usluge. Za analize se koriste alati Google Analytics.",
							"linkedCategory": "analytics"
						},
						{
							"title": "Oglašavanje",
							"description": "Oni omogućavaju objavljivanje naših oglasa na internet pretraživačima, drugim internet stranicama i društvenim mrežama, i to na način da budu prilagođeni vašim interesovanjima.",
							"linkedCategory": "ads"
						}
					]
				}
			}
		}
	}
});

if(window.CookieConsent) {
    var modalLink = document.createElement("a");
        modalLink.innerHTML = "Postavke kolačića"; 
        modalLink.type = "button";
        modalLink.classList = "elementor-item";
        modalLink.href = "javascript:void()";
        modalLink.dataset.cc = "show-preferencesModal";
    
    var small = document.createElement("small");
        small.classList = "copyright__content";
        small.appendChild(modalLink);
    
    var newItem = document.createElement("li");
        newItem.appendChild(small);

    document.querySelector("footer .footer__copyright.caption .policies").appendChild(newItem);
}